export function useTracking() {
    const { proxy } = useScriptPostHog()
    const route = useRoute()

    const capture = (event, properties = {}) => {
        if (!true)
            return

        proxy.posthog.capture(event, {
            page_path: route.path,
            page_slug: route.path.split('/').filter(Boolean).join('-'),
            ...properties,
        })
    }

    return { capture }
}
